import { Dispatch } from 'redux';
import { fetchLastPrice,fetchLastPriceBySymbol, PriceItem } from '../services/latestPriceService';
interface ReceivePriceListAction {
    type: 'RECEIVE_PRICE_LIST';
    prices: PriceItem[];
  }

export function getPriceList() {
    return (dispatch: Dispatch<ReceivePriceListAction> ) => {
        dispatch({ type: 'RECEIVE_PRICE_LIST', prices: [], loading: true });
        fetchLastPrice().then((response) => {
            dispatch({ type: 'RECEIVE_PRICE_LIST', prices: response, loading: false });
        }).catch((error) => {
            console.error('Error fetching price list:', error);
            dispatch({ type: 'RECEIVE_PRICE_LIST', prices: [], loading: false });
        });
    };
}
export function getPriceListBySymbol(symbol: string) {
    return (dispatch: Dispatch ) => {
        fetchLastPriceBySymbol(symbol).then((response) => {
            dispatch({ type: 'RECEIVE_LAST_PRICE', symbol: response, loading: false });
        }).catch((error) => {
            console.error('Error fetching symbol price:', error);
            dispatch({ type: 'RECEIVE_LAST_PRICE', symbol: {}, loading: false });
        });
    };
}